import { presentationLocale } from './calendarLabels';

export const formatNumber = (value, language, options = {}) => new Intl.NumberFormat(presentationLocale(language), options).format(value);
export const formatMoney = (value, language, options = {}) => formatNumber(value, language, { style: 'currency', currency: 'PLN', ...options });
